import { useCallback, useMemo } from 'react';
import { useClientConfig } from '../common/client/ClientConfigProvider';
import {
    formatCurrency,
    formatDate,
    formatDateTime,
    formatTime,
    getCurrencySymbol,
} from '../utils/formatters';

export const useFormatCurrency = (): ((amount: number) => string) => {
    const { locale } = useClientConfig();
    return useCallback(
        (amount: number) => formatCurrency(amount, locale.currency),
        [locale.currency],
    );
};

export const useCurrencySymbol = (): string => {
    const { locale } = useClientConfig();
    return useMemo(() => getCurrencySymbol(locale.currency), [locale.currency]);
};

export const useFormatDate = (): ((date: Date, format?: string) => string) => {
    const { locale } = useClientConfig();
    return useCallback(
        (date: Date, format?: string) => formatDate(date, locale.timezone, format),
        [locale.timezone],
    );
};

export const useFormatTime = (): ((date: Date, format?: string) => string) => {
    const { locale } = useClientConfig();
    return useCallback(
        (date: Date, format?: string) => formatTime(date, locale.timezone, format),
        [locale.timezone],
    );
};

export const useFormatDateTime = (): ((date: Date, format?: string) => string) => {
    const { locale } = useClientConfig();
    return useCallback(
        (date: Date, format?: string) => formatDateTime(date, locale.timezone, format),
        [locale.timezone],
    );
};
